export const YM_COUNTER = 96470515